import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { CalculateVenueEnv } from '../entities/calculate-venue-env.entity';

type Params = {
  projectId: number;
};

type Result = {
  env: CalculateVenueEnv;
};

export const runImpactCalculateVenueEnvForProject = createAppAsyncThunk(
  'impactCalculateVenue/runImpactCalculateVenueEnvForProject',
  async (
    params: Params,
    { extra: { impactCalculateVenueGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const modelVersion = 'ENV_SEASON';
      const calculateEnv =
        await impactCalculateVenueGateway.runImpactCalculateVenueEnvForProject(
          params.projectId,
          modelVersion,
        );
      return { env: calculateEnv };
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
